import { Component, OnInit } from '@angular/core';

import { DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';

import { OptionService } from '../../services/option.service';

import { OptionsControlBaseComponent } from '../options-control-base/options-control-base.component';

import { removeFromArray } from '../../utils/utils';
import { ControlTypeName } from '../../types/control-type-name';
import { ControlValidateMoment } from '../../types/validator.types';
import { OptionItem } from '../../types/control.types';

@Component({
  selector: 'df-multi-check-box',
  templateUrl: './multi-check-box.component.html',
  styleUrls: ['./multi-check-box.component.scss']
})
export class MultiCheckBoxComponent extends OptionsControlBaseComponent<MultiOptionItem> implements OnInit {
  type = ControlTypeName.multiCheckBox;

  constructor(protected commonConfig: DynamicFormCommonConfig, protected service: OptionService) {
    super(commonConfig, service);
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (!this.model.value) {
      this.model.value = [];
    }
  }

  convertOptions() {
    if (!this.options) {
      this.options = [
        { id: `éé¡¹1`, text: `éé¡¹1` },
        { id: `éé¡¹2`, text: `éé¡¹2` },
        { id: `éé¡¹3`, text: `éé¡¹3` }
      ];
    }
    this.showOptions = this.options.map((s) => {
      return {
        ...s,
        checked: this.checkedState(s)
      };
    });
  }

  change(d: any) {
    if (d.checked) {
      this.model.value.push(d.id);
    } else {
      removeFromArray(this.model.value, d.id);
    }
    this.validateAtMoment(ControlValidateMoment.Input);
    this.validateAtMoment(ControlValidateMoment.Change);

    this.broadControlValueChange();
  }

  // è®¾ç½®å¼æ¶ï¼å»æä¸ç¬¦åé¡¹çå¼
  setModelValue(val: any) {
    let temp: any[] = [];
    if (val instanceof Array) {
      temp = val;
    }
    if (typeof val === 'string' && val !== '') {
      temp = JSON.parse(val);
      // é¿åé»è®¤å¼è½¬æ¢åï¼ä¸æ­£ç¡®
      if (!(temp instanceof Array)) {
        temp = [val];
      }
    }
    if (!this.isOptionLoadComplete) {
      this.model.value = temp;
      return;
    }
    const values: any[] = [];
    if (this.showOptions) {
      this.showOptions.forEach((s) => {
        s.checked = temp.filter((p: any) => p === s.id).length > 0;
        if (s.checked) {
          values.push(s.id);
        }
      });
    }
    this.model.value = values;
  }

  getModelValue(): any {
    const checked = this.getChecked();
    if (checked) {
      return JSON.stringify(checked.map((s) => s.id));
    }
    return JSON.stringify([]);
  }

  getCheckedText(): string {
    return this.getChecked()
      .map((s) => s.text)
      .join(',');
  }

  private checkedState(option: MultiOptionItem) {
    return (
      this.model.value &&
      this.model.value instanceof Array &&
      this.model.value.filter((p: any) => p === option.id).length > 0
    );
  }

  private getChecked(): Array<MultiOptionItem> {
    if (!this.showOptions) {
      return [];
    }
    return this.showOptions.filter((s) => s.checked);
  }
}

export class MultiOptionItem implements OptionItem {
  id: string;
  text: string;
  checked?: boolean;
}
